import { airbrakeService } from '../services/airbrake';

export interface ApiLogContext {
  method: string;
  url: string;
  params?: any;
  data?: any;
  headers?: any;
  duration?: number;
  status?: number;
  userId?: number;
  userName?: string;
}

export class ApiLogger {
  static logError(context: ApiLogContext, error: any): void {
    const errorData = {
      type: 'API_ERROR',
      timestamp: new Date().toISOString(),
      method: context.method,
      url: context.url,
      status: error?.response?.status || 'NETWORK_ERROR',
      errorMessage: error?.message || 'Unknown error',
      errorData: error?.response?.data,
      duration: context.duration,
      userId: context.userId,
      userName: context.userName,
      params: context.params,
      requestData: context.data
    };

    console.error(`[API ERROR] ${context.method} ${context.url} - ${errorData.status}`, errorData);

    // Report to Airbrake
    airbrakeService.notify(error, {
      apiCall: true,
      method: context.method,
      url: context.url,
      status: error?.response?.status,
      params: context.params,
      requestData: context.data,
      responseData: error?.response?.data,
      duration: context.duration,
      userId: context.userId,
      userName: context.userName
    });
  }
}

// Utility function to wrap API calls with error logging only
export const withApiErrorLogging = async <T>(
  apiCall: () => Promise<T>,
  context: Omit<ApiLogContext, 'duration'>
): Promise<T> => {
  const startTime = Date.now();
  
  try {
    const response = await apiCall();
    return response;
  } catch (error) {
    const duration = Date.now() - startTime;
    ApiLogger.logError({ ...context, duration }, error);
    throw error;
  }
};
